import api from '@/services/api/api';

export const useMagazineArticles = (slug) => {
  const magazineArticlesData = useQuery(
    ['magazineArticlesData', slug],
    async () => {
      const { data } = await api.magazines.getMagazineArticle(slug);
      return data;
    },
    {
      isEnabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await magazineArticlesData.suspense();
  });

  return magazineArticlesData;
};
